<template>
	<!-- puoi mettere header/breadcrumb condivisi se ti servono -->
	<!-- ✱ router-view con chiave dinamica
	   La chiave cambia ogni volta che cambiano:
	   • il nome della route (Devices / Editor / Data …)
	   • oppure il parametro :deviceId                         -->
	<router-view v-slot="{ Component }">
		<component
			:is="Component"
			:key="routeKey"
		/>
	</router-view>
</template>

<script setup lang="ts">
	import { useRoute } from "vue-router";
	import { computed } from "vue";

	const route = useRoute();
	const routeKey = computed(() => String(route.name) + "-" + (route.params.deviceId ?? "new"));
</script>
